import axios from "axios";
import { apiUrl, getAuthHeader } from "./base";

const exportCohort = async (cohortId: string, type: string) => {
  try {
    const req = await axios.get(
      apiUrl(`/apiexport/${cohortId}?type=${type ?? ``}`),
      await getAuthHeader()
    );

    if (req.data.result !== "OK") {
      throw new Error(
        req.data.message ?? "Unable to view submission. It may not exist."
      );
    }
    return {
      status: true as true,
      message: "OK",
      data: req.data.data,
    };
  } catch (err) {
    return {
      status: false as false,
      message: err.message,
    };
  }
};

const ApiExport = { exportCohort };

export default ApiExport;
